import menu from "./cs/menu.json";
import banner from "./cs/banner.json";
import profiles from "./cs/profiles.json";
import employees from "./cs/employees.json";
import pages from "./cs/pages.json";
import gallery from "./cs/gallery.json";
import documents from "./cs/documents.json";
import priceList from "./cs/pricelist.json";
import notifications from "./cs/notifications.json";
import articles from "./cs/articles.json";
import events from "./cs/events.json";
import products from "./cs/products.json";
import orders from "./cs/orders.json";
import vacancies from "./cs/vacancies.json";
import profile from "./cs/profile.json";
import privileges from "./cs/privileges.json";
import settings from "./cs/settings.json";
import login from "./cs/login.json";
import dashboard from "./cs/dashboard.json";
import errors from "./cs/errors.json";

import common from "./cs/common.json";

import categoriesComponent from "./cs/components/categories.json";
import itemsControllerComponent from "./cs/components/items-controller.json";
import imageInputComponent from "./cs/components/image-input.json";

export const CS = {
	menu: menu,
	banner: banner,
	profiles: profiles,
	employees: employees,
	pages: pages,
	gallery: gallery,
	documents: documents,
	priceList: priceList,
	notifications: notifications,
	articles: articles,
	events: events,
	products: products,
	orders: orders,
	vacancies: vacancies,
	profile: profile,
	privileges: privileges,
	settings: settings,
	login: login,
	dashboard: dashboard,
	errors: errors,
	common: common,
	categoriesC: categoriesComponent,
	itemsControllerC: itemsControllerComponent,
	imageInputC: imageInputComponent,
};
